import { LineType } from '../../../api.js';
import { Color4 as BABYLON_Color4 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.color.js';
import { Vector4 as BABYLON_Vector4, Matrix as BABYLON_Matrix } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { matrix_pool, vector4_pool } from '../../../Math.js';
import { DebugVisualizer } from './DebugVisualizer.js';
export class FrustumVisualizer extends DebugVisualizer {
    constructor(viewer, _color = new BABYLON_Color4(1), _line_thickness = 0.05, _line_type = LineType.SOLID) {
        super(viewer);
        this._color = _color;
        this._line_thickness = _line_thickness;
        this._line_type = _line_type;
    }
    update() {
        this.remove_lines(0);
        const view = matrix_pool.fetch();
        BABYLON_Matrix.IdentityToRef(view);
        const projection = matrix_pool.fetch();
        BABYLON_Matrix.IdentityToRef(projection);
        const is_valid_matrices = this.get_matrices_ref(view, projection);
        if (!is_valid_matrices) {
            return;
        }
        const inverse_view_projection_matrix = view.multiplyToRef(projection, matrix_pool.fetch());
        inverse_view_projection_matrix.invert();
        // Range to get world is -1 to 1
        // [X, Y, depth]
        const vertex_definitions = [
            [-1, -1, -1], [-1, +1, -1], // left lower near -> left upper near
            [-1, +1, -1], [+1, +1, -1], // left upper near -> right upper near
            [+1, +1, -1], [+1, -1, -1], // right upper near -> right lower near
            [+1, -1, -1], [-1, -1, -1], // right lower near -> left lower near
            [-1, -1, +1], [-1, +1, +1], // left lower far -> left upper far
            [-1, +1, +1], [+1, +1, +1], // left upper far -> right upper far
            [+1, +1, +1], [+1, -1, +1], // right upper far -> right lower far
            [+1, -1, +1], [-1, -1, +1], // right lower far -> left lower far
            [-1, -1, -1], [-1, -1, +1], // left lower near -> left lower far
            [-1, +1, -1], [-1, +1, +1], // left upper near -> left upper far
            [+1, +1, -1], [+1, +1, +1], // right upper near -> right upper far
            [+1, -1, -1], [+1, -1, +1] // right lower near -> right lower far
        ];
        let line_index = 0;
        const from_projected = vector4_pool.fetch();
        const to_projected = vector4_pool.fetch();
        for (let index = 0; index < vertex_definitions.length; index += 2) {
            const element = vertex_definitions[index];
            const next_element = vertex_definitions[(index + 1) % vertex_definitions.length];
            const from_screenspace_x = element[0];
            const from_screenspace_y = element[1];
            const from_nearfar = element[2];
            const to_screenspace_x = next_element[0];
            const to_screenspace_y = next_element[1];
            const to_nearfar = next_element[2];
            // Project the given normalized coordinates onto the image (near) and far plane.
            BABYLON_Vector4.TransformCoordinatesFromFloatsToRef(from_screenspace_x, from_screenspace_y, from_nearfar, inverse_view_projection_matrix, from_projected);
            BABYLON_Vector4.TransformCoordinatesFromFloatsToRef(to_screenspace_x, to_screenspace_y, to_nearfar, inverse_view_projection_matrix, to_projected);
            from_projected.scaleInPlace(1.0 / from_projected.w);
            to_projected.scaleInPlace(1.0 / to_projected.w);
            this.draw_line(line_index, from_projected.toVector3(), to_projected.toVector3(), this._color, this._line_thickness, this._line_type);
            line_index++;
        }
        matrix_pool.return(view, projection, inverse_view_projection_matrix);
        vector4_pool.return(from_projected, to_projected);
    }
}
//# sourceMappingURL=FrustumVisualizer.js.map